import Switch from "components/switch";
import {
  FieldErrors,
  FieldValues,
  Path,
  RegisterOptions,
  UseFormRegister,
} from "react-hook-form";

interface ISwitchFieldProps<T> {
  id: Path<T>;
  label: string;
  desc: string;
  placeholder: string;
  mt: any;
  mb: any;
  defaultValue?: any;
  register?: UseFormRegister<T>;
  errors?: FieldErrors<T>;
  validationSchema?: RegisterOptions<T>;
}

const SwitchField = <T,>(props: ISwitchFieldProps<T>) => {
  const {
    id,
    label,
    errors,
    register,
    validationSchema,
    desc,
    mt,
    mb,
    defaultValue,
  } = props;
  return (
    <div
      className={`flex flex-col justify-between ${mt} ${mb} items-start gap-2`}
    >
      <label
        htmlFor={id}
        className="flex items-center gap-2 hover:cursor-pointer"
      >
        <h5 className="w-full whitespace-nowrap text-base font-bold text-navy-700 dark:text-white">
          {label}
        </h5>
        <p className={`text-base text-gray-600`}>{desc}</p>
      </label>
      <div>
        <Switch
          id={id}
          checked={defaultValue}
          errors={errors}
          register={register}
          validationSchema={validationSchema}
        />
      </div>
    </div>
  );
};

export default SwitchField;
